export default __webpack_public_path__ + "static/media/offer-chocolate@3x.df863baf.png";